import { connect } from 'react-redux';
import { selectReviewsStatistics, selectIsReviewsStatisticsLoading, isAnyFilterSelected } from '../Ratings.selectors';
import ReviewsStatistics from './ReviewsStatistics';

const mapStateToProps = state => ({
  reviewsStatistics: selectReviewsStatistics(state),
  isLoading: selectIsReviewsStatisticsLoading(state),
  hasActiveFilters: isAnyFilterSelected(state),
});

export default connect(mapStateToProps)(ReviewsStatistics);
